import BootslideMenu from 'scoreboard/components/bootslide/bootslide-menu'
import BootslideClickableMenuOption from 'scoreboard/components/bootslide/bootslide-clickable-menu-option'
import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'

/**
 * A customizable bootslide menu which contains bootslide-clickable-menu-option(s).
 */
const BootslideClickableMenu = BootslideMenu.extend({
	/**
	 * @param {Array} options.menuOptions options which are to be shown in the bootslide menu
	 */
	initialize(options) {
		BootslideMenu.prototype.initialize.apply(this, arguments)
		this.menuOptions = options.menuOptions
	},

	menu() {
		let target = []
		_.each(this.menuOptions, o => {
			target.push({
				label: o.label,
				contentView: BootslideClickableMenuOption.extend({
					icon: o.icon,
					label: i18n.get(o.label),
					_onClick: e => this.trigger('click', { e, handler: o.handler })
				})
			})
		})

		return {
			label: i18n.get('common.options'),
			target
		}
	}
})

export default BootslideClickableMenu

BootslideClickableMenu.__filename__ = 'components/bootslide/bootslide-clickable-menu.js'
